

export default ({
  data () {
    return {
      answer: null,
      freeTextAnswer: ''
    }
  },
  computed: {
    challenges () {
      const options = [
        { id: 'strategy', label: 'Strategy' },
        { id: 'financial', label: 'Financial' },
        { id: 'esg', label: 'ESG' },
        { id: 'sales-and-marketing', label: 'Sales & Marketing' },
        { id: 'hr', label: 'HR' }
      ]
      options.push(
        { id: 'other', label: 'Other' }
      )
      return options
    }
  },
  watch: {
    freeTextAnswer (value) {
      this.$emit('input', value)
    },
    answer (value) {
      if (value === 'other') {
        this.$emit('input', null)
        this.$nextTick(() => {
          this.$refs.freeText.focus()
        })
      } else {
        this.$emit('input', value)
      }
    }
  }
})
